import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { WithChildrenCommonProps } from '@types';
import { getOptionListStylesAsClassName, getOptionListHeightStyle } from './option-list-styles';
export interface IOptionListProps {
  /** Number of maximum visible options in the container without scroll */
  maxVisibleOptions?: number;
  /** Add half of the heigth of an option to the containers height */
  addHalfOption?: boolean;
}
export const OptionList = t0 => {
  const $ = _c(9);
  const {
    maxVisibleOptions: t1,
    addHalfOption: t2,
    children
  } = t0;
  const maxVisibleOptions = t1 === undefined ? 5 : t1;
  const addHalfOption = t2 === undefined ? true : t2;
  let t3;
  if ($[0] !== children) {
    t3 = React.Children.toArray(children);
    $[0] = children;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const totalNumberOfItems = t3.length;
  const roundedMaxVisibleOptions = maxVisibleOptions >= totalNumberOfItems ? totalNumberOfItems : maxVisibleOptions + (addHalfOption ? 0.5 : 0);
  let t4;
  if ($[2] !== roundedMaxVisibleOptions) {
    t4 = getOptionListHeightStyle(roundedMaxVisibleOptions);
    $[2] = roundedMaxVisibleOptions;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t4) {
    t5 = {
      height: t4
    };
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== children || $[7] !== t5) {
    t6 = <div role="menu" className={getOptionListStylesAsClassName} style={t5}>{children}</div>;
    $[6] = children;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
};